import styled from 'styled-components';

const SearchRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const EmailSearchInput = styled.input`
  &&&&& {
    margin: 0;
  }
`;

const SearchResults = styled.div`
  display: flex;
  flex-direction: column;
`;

const ResultsTable = styled.table`
  text-align: left;
  margin: 1em;
  tbody {
    tr {
      height: 2em;
      &:nth-child(odd) {
        background: #efefef;
      }
    }
  }
`;

export {
  SearchRow,
  EmailSearchInput,
  SearchResults,
  ResultsTable
};